import React from 'react'
import styled from 'styled-components'

import { SIZES, FONT_WEIGHTS } from '~/common/globalStyles'
import Text from '~/views/components/ui/Text'

export const CardHeader = styled.div(
  ({ theme }) => `
  padding: ${SIZES.xl};
  border-bottom: 1px solid ${theme.palette.divider};
`,
)

export const CardBody = styled.div.attrs((props) => ({
  children: props.children,
}))`
  padding: ${SIZES.xl};
  height: calc(100% - 72px);
  display: flex;
  align-items: center;
`

const AttributeLabel = styled.div`
  font-weight: ${FONT_WEIGHTS.bold};
  margin-bottom: ${SIZES.xxs};
`
const AttributeLabelWrapper = styled.div`
  margin-left: ${SIZES.ultra};
  max-width: 50%;

  &:first-child {
    margin-left: 0;
  }
`

interface Props {
  title: string
  value: string | number
  dataTestId?: string
}

export const LabeledAttribute = (props: Props) => (
  <AttributeLabelWrapper>
    <AttributeLabel>
      <Text size="medium" weight="bold">
        {props.title}
      </Text>
    </AttributeLabel>
    <Text data-testid={props.dataTestId} size="medium">
      {props.value}
    </Text>
  </AttributeLabelWrapper>
)

const SmallDataWrapper = styled.div`
  margin-right: ${SIZES.mega};
`

const SmallDataLabelWrapper = styled.div`
  margin-bottom: ${SIZES.xxs};
`

interface SmallLabeledDataProps extends Props {
  color?: string
  'data-testid'?: string
}

export const SmallLabeledData = (props: SmallLabeledDataProps) => (
  <SmallDataWrapper>
    <SmallDataLabelWrapper>
      <Text size="medium" color="mediumGray">
        {props.title}
      </Text>
    </SmallDataLabelWrapper>
    <Text
      data-testid={props['data-testid']}
      size="large"
      weight="bold"
      color={props.color}
    >
      {props.value}
    </Text>
  </SmallDataWrapper>
)

export const LargeDataWrapper = styled.div`
  text-align: center;
  margin: auto;
`

export const LargeDataLabelWrapper = styled.div`
  margin-bottom: ${SIZES.xxs};
`
